export enum SUBSTITUTION_STATUS {
  SUBSTITUTED = 'substituted',
  NOT_ABLE_TO_SUBSTITUTE = 'not_able_to_substitute',
  NOT_ALLOWED_TO_SUBSTITUTE = 'not_allowed_to_substitute',
  ERROR = 'error',
}

export const SUBSTITUTION_STATUS_VALUES = Object.values(SUBSTITUTION_STATUS)
